import { GallerySelectedMedia, GalleryState, GalleryThumbnails, IMediaType, palette } from "@govlaunch/web";
import Box, { BoxProps } from "@govlaunch/web/src/box/Box";
import React from "react";
import { IStoryFieldsFragment } from "../fragments/__generated__/StoryFieldsFragment.generated";
import { IMediaType as IStoryMediaType } from "../graphql/types";

interface IStoryGalleryProps extends BoxProps {
  story: Pick<IStoryFieldsFragment, "medias" | "title">;
}

export default function StoryGallery({ story, ...props }: IStoryGalleryProps) {
  const { medias } = story;

  if (!medias || medias.length === 0) {
    return null;
  }

  const filteredMedias = medias
    .filter(({ type }) => {
      return type === IStoryMediaType.Youtube || type === IStoryMediaType.Image;
    })
    .map(({ url, type, alt }) => {
      if (!url) {
        return null;
      }

      if (type === IStoryMediaType.Youtube) {
        return {
          type: IMediaType.Youtube,
          url,
          alt: "",
        };
      }

      if (type === IStoryMediaType.Image) {
        return {
          type: IMediaType.Image,
          url,
          alt,
        };
      }

      return null;
    })
    .filter(notUndefinedOrNull);

  return (
    <Box
      {...props}
      css={{
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: palette.gray[100],
        paddingTop: 10,
        paddingBottom: 10,
        marginBottom: 30,
      }}
    >
      <GalleryState medias={filteredMedias}>
        <GallerySelectedMedia storyTitle={story.title} />

        {filteredMedias.length > 1 && <GalleryThumbnails storyTitle={story.title} />}
      </GalleryState>
    </Box>
  );
}

function notUndefinedOrNull<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
